import { z } from "zod";

import { subscriptionSchema } from "@/features/billing/models";
import { SUBSCRIPTION_VENDOR } from "@/shared/domains";
import { availableLanguageSchema } from "@/shared/models";
import { APPOINTMENT_TYPE, POST_MEETING_STATUS } from "./constants";

export const providerSchema = z.object({
  id: z.string(),
  fullName: z.string(),
});

const timeSlotSchema = z.object({
  providerId: providerSchema.shape.id,
  dateTime: z.string().datetime({ offset: true }),
});

export const appointmentSchema = z.object({
  id: z.string(),
  title: z.string(),
  type: z.enum(APPOINTMENT_TYPE),
  confirmed: z.boolean(),
  startTime: z.iso.datetime({ offset: true }),
  endTime: z.iso.datetime({ offset: true }),
  videoUrl: z.string().nullable(),
  timezone: z.string(),
  pmStatus: z.enum(POST_MEETING_STATUS).nullable(),
  provider: providerSchema.nullable(),
  documentId: z.string().nullable(),
  vendor: z.enum(SUBSCRIPTION_VENDOR),
  rescheduleUrl: z.string().nullable(),
  subscriptionId: subscriptionSchema.shape.id.nullable(),
});

export const scheduleAppointmentSchema = z.object({
  type: appointmentSchema.shape.type,
  date: z.iso.date(),
  timeSlot: timeSlotSchema,
  language: availableLanguageSchema,
  subscriptionId: subscriptionSchema.shape.id.optional(),
  vendor: z.enum(SUBSCRIPTION_VENDOR).optional(),
});

export const needsSyncRefillSchema = z.object({
  needsSync: z.boolean(),
});
